import React from "react";
import styled from "styled-components";

import { Stars, Button } from "../../../genericComponents";
//import { Resource } from '../../../../types/Resource';
import { NavLink } from "react-router-dom";
import { Column } from "../../../genericComponents/Layout";
import { ThemeProps as theme } from "../../../genericComponents/globalStyles";

import { useStorage } from "../../../hook/useStorage";

import Bitmap from "../../../../assets/images/sprites/Bitmap.png";


export default function FeaturedItem(props) {
  const { item, onLockerButtonPress, handleWriteReview } = props;

  const url = useStorage(`resources/${item.picture_name}`);

  return (
    <GolbalContainer>
      <ItemContainer>
        <DetailsSection>
          <DetailsTitle>
            <CustomLink to={`/product-page/${item.id}`}>{item.name}</CustomLink>
          </DetailsTitle>
          <DetailsContent>{item.description || "No description"}</DetailsContent>
          <TagsSection480>
            {item.tags
              ? item.tags.map((tagitem, index) => <Tag key={index}>{tagitem}</Tag>)
              : "no tag"}
          </TagsSection480>
          <Footer>
            <ReviewsFooter>
              <Stars color='yellow' numberOfStars={item.rating || 0} />
              <Reviews>{item.reviewsCount || 0} Reviews</Reviews>
            </ReviewsFooter>
            <Range>${item.price_from} - ${item.price_to}</Range>
            <Button
              backgroundColor={theme.color.gabaYellow}
              color={theme.color.darkBlue}
              onClick={() => handleWriteReview(item.id, item.name)}
            >
              Write Review
            </Button>
            <AddToLocker
              onClick={() => onLockerButtonPress(item.id, !!item.onLocker)}
              backgroundColor={theme.color.darkBlue}
              color={theme.color.white}
            >
              {item.onLocker ? "Remove from locker" : "Add to Locker"}
            </AddToLocker>
          </Footer>
        </DetailsSection>
        <TagsSection720>
          {item.tags
            ? item.tags.map((tagitem, index) => <Tag key={index}>{tagitem}</Tag>)
            : "no tag"}
        </TagsSection720>
      </ItemContainer>
      {url !== "" ? <Image src={url} /> : <Image src={Bitmap} />}
    </GolbalContainer>
  );
};


const GolbalContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
const ItemContainer = styled.div`
  background: ${(props) => props.theme.color.softYellow};
  border-radius: 6px;
  margin-bottom: 30px;
  display: flex;
  padding: 30px;
  flex: 1;
  min-width: 280px;
`;
const Image = styled.img`
  height: 190px;
  width: 280px;
  margin: 0 16px;
  object-fit: contain;
  @media (max-width: 980px) {
    display: none;
  }
`;
const AddToLocker = styled(Button)`
  font-size: 1.6em;
`;
const DetailsSection = styled(Column)`
  width: 60%;
  min-width: 280px;
  @media (max-width: 720px) {
    width: 100%;
  }
`;
const CustomLink = styled(NavLink)`
  color: ${(props) => props.theme.color.darkBlue};
`;
const DetailsTitle = styled.h3`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.7em;
  font-weight: bold;
  letter-spacing: -0.1px;
  line-height: 32px;
  margin-bottom: 15px;
`;
const DetailsContent = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.2em;
  letter-spacing: 0.1px;
  line-height: 24px;
  text-align: justify;
`;
const ReviewsFooter = styled.div`
  display: flex;
  margin: 0px 20px 10px -5px;
`;
const Footer = styled(Column)``;
const Reviews = styled.div`
  margin-left: 20px;
  margin-top: 15px;
  font-size: 1.2em;
`;
const TagsSection720 = styled.div`
  display: flex;
  flex:1;
  flex-direction: row;
  margin-top: 50px;
  margin-left: 20px;
  flex-wrap: wrap;
  height: fit-content;
  font-size: 1.1em;
  @media (max-width: 720px) {
    display: none;
  }
`;
const TagsSection480 = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  height: fit-content;
  font-size: 1.1em;
  display: none;
  @media (max-width: 720px) {
    display: flex;
  }
`;
const Tag = styled.div`
  background: ${(props) => props.theme.color.softPurple};
  border-radius: 6px;
  padding: 6px 10px;
  margin-right: 10px;
  margin-bottom: 5px;
`;
const Range = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.2em;
  letter-spacing: 0.1px;
`;